import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import { AccessLevelIcon } from '@dbt-labs/dbt-dag';

import { FilterState } from '@/context/FilterProvider';
import { AccessType } from '@/typings/dbt';
import { toTitleCase } from '@/util/string';
import { BaseFilterToggle, FilterToggleProps } from './BaseFilterToggle';

interface ModelAccessToggleProps extends FilterToggleProps {
  accessLevel: AccessType;
  onToggle: FilterState['updateFilters'];
  count?: number;
}

export const ModelAccessToggle: FC<ModelAccessToggleProps> = (props) => {
  const { accessLevel, isChecked, count } = props;

  const onToggle = () => props.onToggle({ access: [accessLevel] }, !isChecked);

  return (
    <BaseFilterToggle {...props} compact onToggle={onToggle} count={count}>
      <AccessLevelIcon
        access={accessLevel}
        size="xs"
        className={twJoin(
          'flex-0',
          isChecked && 'text-fgMain',
          !isChecked && 'text-fgDecorative',
        )}
      />
      <span className="flex-1">{toTitleCase(accessLevel)}</span>
    </BaseFilterToggle>
  );
};
